import DashboardV2 from '../pages/DashboardV2'
// import Composer from './Composer'

export default DashboardV2
